export default "__VITE_ASSET__Cjv2Rsdc__"